import { useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import { CurrentUserContext } from "App";
import defaultAvatar from "../../../assets/sampleAvatar.png";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3080";

export default function RecentSearchPersonComponent({
  searchPersonID,
  avatar,
  username,
  following,
}) {
  const { currentUser } = useContext(CurrentUserContext);
  const [followed, setFollowed] = useState(following);
  const navigate = useNavigate();

  function navigateToSearchedPerson() {
    return navigate(`/profile?username=${username}`, {
      state: { searchPersonID: searchPersonID },
    });
  }

  function follow() {
    fetch(`${API_URL}/updateUserConnections`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${currentUser.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ username: username, status: "followed" }),
    })
      .then((r) => r.json())
      .then((r) => {
        if (r.message === "success") {
          setFollowed(true);
        }
      })
      .catch((err) => console.error(err));
  }

  function unfollow() {
    fetch(`${API_URL}/updateUserConnections`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${currentUser.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ username: username, status: "unfollowed" }),
    })
      .then((r) => r.json())
      .then((r) => {
        if (r.message === "success") {
          setFollowed(false);
        }
      })
      .catch((err) => console.error(err));
  }

  return (
    <div
      id="recentSearchPersonCard"
      className="d-flex align-items-center justify-content-between gap-3 w-100"
      style={{
        maxWidth: "30rem",
        padding: "0.6rem 0.75rem",
        borderRadius: "12px",
        backgroundColor: "rgba(30, 25, 45, 0.6)",
        border: "1px solid rgba(185,151,255,0.08)",
      }}
    >
      {/* AVATAR */}
      <div
        style={{ width: "3rem", height: "3rem", flexShrink: 0 }}
        onClick={navigateToSearchedPerson}
      >
        <img
          style={{ width: "3rem", height: "3rem" }}
          src={avatar && avatar !== "sampleAvatar.png" ? avatar : defaultAvatar}
          alt="Avatar Icon"
          className="rounded-circle"
          draggable={false}
        />
      </div>
      {/* PERSON'S NAME */}
      <span
        className="me-auto"
        style={{ fontSize: "1rem", fontWeight: 500 }}
        onClick={navigateToSearchedPerson}
      >
        {username}
      </span>
      {/* Following Status Icon */}
      {username !== currentUser.username ? (
        followed ? (
          <div style={{ maxWidth: "2.4rem" }}>
            <svg
              onClick={unfollow}
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_408_4237"
                style={{ maskType: "alpha" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
              >
                <rect width="24" height="24" fill="var(--light-white)" />
              </mask>
              <g mask="url(#mask0_408_4237)">
                <path
                  d="M17.55 9.175L21.075 5.625C21.275 5.425 21.5125 5.325 21.7875 5.325C22.0625 5.325 22.3 5.425 22.5 5.625C22.7 5.825 22.8 6.0625 22.8 6.3375C22.8 6.6125 22.7 6.85 22.5 7.05L18.25 11.3C18.05 11.5 17.8167 11.6 17.55 11.6C17.2833 11.6 17.05 11.5 16.85 11.3L14.725 9.175C14.525 8.975 14.425 8.7375 14.425 8.4625C14.425 8.1875 14.525 7.95 14.725 7.75C14.925 7.55 15.1583 7.45 15.425 7.45C15.6917 7.45 15.925 7.55 16.125 7.75L17.55 9.175ZM9 12C7.9 12 6.95833 11.6083 6.175 10.825C5.39167 10.0417 5 9.1 5 8C5 6.9 5.39167 5.95833 6.175 5.175C6.95833 4.39167 7.9 4 9 4C10.1 4 11.0417 4.39167 11.825 5.175C12.6083 5.95833 13 6.9 13 8C13 9.1 12.6083 10.0417 11.825 10.825C11.0417 11.6083 10.1 12 9 12ZM1 18V17.2C1 16.6333 1.14583 16.1125 1.4375 15.6375C1.72917 15.1625 2.11667 14.8 2.6 14.55C3.63333 14.0333 4.68333 13.6458 5.75 13.3875C6.81667 13.1292 7.9 13 9 13C10.1 13 11.1833 13.1292 12.25 13.3875C13.3167 13.6458 14.3667 14.0333 15.4 14.55C15.8833 14.8 16.2708 15.1625 16.5625 15.6375C16.8542 16.1125 17 16.6333 17 17.2V18C17 18.55 16.8042 19.0208 16.4125 19.4125C16.0208 19.8042 15.55 20 15 20H3C2.45 20 1.97917 19.8042 1.5875 19.4125C1.19583 19.0208 1 18.55 1 18Z"
                  fill="white"
                />
              </g>
            </svg>
          </div>
        ) : (
          <div style={{ maxWidth: "2.4rem" }}>
            <svg
              style={{ maxWidth: "2.4rem", maxHeight: "2.4rem" }}
              onClick={follow}
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <mask
                id="mask0_408_4234"
                style={{ maskType: "alpha" }}
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
              >
                <rect width="24" height="24" fill="var(--light-white)" />
              </mask>
              <g mask="url(#mask0_408_4234)">
                <path
                  d="M18 11H16C15.7167 11 15.4792 10.9042 15.2875 10.7125C15.0958 10.5208 15 10.2833 15 10C15 9.71667 15.0958 9.47917 15.2875 9.2875C15.4792 9.09583 15.7167 9 16 9H18V7C18 6.71667 18.0958 6.47917 18.2875 6.2875C18.4792 6.09583 18.7167 6 19 6C19.2833 6 19.5208 6.09583 19.7125 6.2875C19.9042 6.47917 20 6.71667 20 7V9H22C22.2833 9 22.5208 9.09583 22.7125 9.2875C22.9042 9.47917 23 9.71667 23 10C23 10.2833 22.9042 10.5208 22.7125 10.7125C22.5208 10.9042 22.2833 11 22 11H20V13C20 13.2833 19.9042 13.5208 19.7125 13.7125C19.5208 13.9042 19.2833 14 19 14C18.7167 14 18.4792 13.9042 18.2875 13.7125C18.0958 13.5208 18 13.2833 18 13V11ZM9 12C7.9 12 6.95833 11.6083 6.175 10.825C5.39167 10.0417 5 9.1 5 8C5 6.9 5.39167 5.95833 6.175 5.175C6.95833 4.39167 7.9 4 9 4C10.1 4 11.0417 4.39167 11.825 5.175C12.6083 5.95833 13 6.9 13 8C13 9.1 12.6083 10.0417 11.825 10.825C11.0417 11.6083 10.1 12 9 12ZM1 18V17.2C1 16.6333 1.14583 16.1125 1.4375 15.6375C1.72917 15.1625 2.11667 14.8 2.6 14.55C3.63333 14.0333 4.68333 13.6458 5.75 13.3875C6.81667 13.1292 7.9 13 9 13C10.1 13 11.1833 13.1292 12.25 13.3875C13.3167 13.6458 14.3667 14.0333 15.4 14.55C15.8833 14.8 16.2708 15.1625 16.5625 15.6375C16.8542 16.1125 17 16.6333 17 17.2V18C17 18.55 16.8042 19.0208 16.4125 19.4125C16.0208 19.8042 15.55 20 15 20H3C2.45 20 1.97917 19.8042 1.5875 19.4125C1.19583 19.0208 1 18.55 1 18Z"
                  fill="var(--main-white)"
                />
              </g>
            </svg>
          </div>
        )
      ) : null}
    </div>
  );
}
